import { render, staticRenderFns } from "./MainJouTempCard.vue?vue&type=template&id=af0bcfd0&scoped=true&"
import script from "./MainJouTempCard.vue?vue&type=script&lang=js&"
export * from "./MainJouTempCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouTempCard.vue?vue&type=style&index=0&id=af0bcfd0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0bcfd0",
  null
  
)

export default component.exports